const navigationSubNav = function() {
    function handleSubNavTogglers() {
        const subNavTogglers = document.querySelectorAll('#header-main-nav-container #header-main-nav ul.menu li.children');

        if (window.innerWidth <= 1200) {
            subNavTogglers.forEach(subNavToggler => {
                // Falls der Event Listener noch nicht gesetzt wurde, füge ihn hinzu
                if (!subNavToggler.dataset.listenerAdded) {
                    subNavToggler.addEventListener('click', toggleSubNav);
                    subNavToggler.dataset.listenerAdded = "true"; // Markiere, dass er bereits gesetzt wurde
                }
            });
        } else {
            subNavTogglers.forEach(subNavToggler => {
                // Entferne alle Event Listener, wenn der Bildschirm größer wird
                subNavToggler.removeEventListener('click', toggleSubNav);
                delete subNavToggler.dataset.listenerAdded;

                // Stelle sicher, dass alle Submenüs geschlossen sind
                subNavToggler.parentElement.classList.remove('open');
                subNavToggler.classList.remove('open');
            });
        }
    }

    // Hilfsfunktion für den Click-Event Listener
    function toggleSubNav() {
        this.parentElement.classList.toggle('open');
        this.classList.toggle('open');
    }

    // Initial ausführen
    handleSubNavTogglers();

    // Event Listener für das Resize-Event
    window.addEventListener('resize', handleSubNavTogglers);



    $('.navbar-toggler').click(function (event) {
        event.preventDefault();
        $(this).toggleClass("open");
        $('#header-main-nav-container, html, body').toggleClass("open");
      });

      //ADD CLASS BY SCROLLING

      $(window).scroll(function(){
        var st = $(window).scrollTop();
        if ( st > 0 ) {
          $('header').addClass('stick');
        } else {
          $('header').removeClass('stick');
        }
      });

      var st = $(window).scrollTop();
      if ( st > 0 ) {
        $('header').addClass('stick');
      } else {
        $('header').removeClass('stick');
      }

    function updateHeaderPadding() {
        const headerHeight = document.querySelector('header').offsetHeight;
        document.querySelector('main').style.paddingTop = `${headerHeight}px`;
    }

    // Initial beim Laden
    updateHeaderPadding();

    // Bei Größenänderung des Fensters
    window.addEventListener('resize', updateHeaderPadding);

    let currentUrl = window.location.href.toLowerCase(); // Um Groß-/Kleinschreibung zu ignorieren
    let menuChildren = $('#main-menu').children('li');

    menuChildren.each(function() {
        let link = $(this).find('a').attr('href');

        if (link) {
            let normalizedLink = link.toLowerCase(); // Um auch /Blog/ korrekt zu erfassen

            if (currentUrl.includes('/news/') && (normalizedLink.includes('/news/') || normalizedLink.includes('/news'))) {
                $(this).addClass('active');
            }
        }
    });

    let menuFooter = $('#menu-neuigkeiten-footer').children('li');

    menuFooter.each(function() {
        let link = $(this).find('a').attr('href');

        if (link) {
            let normalizedLink = link.toLowerCase(); // Um auch /Blog/ korrekt zu erfassen

            if (currentUrl.includes('/news/') && (normalizedLink.includes('/news/') || normalizedLink.includes('/news'))) {
                $(this).addClass('active');
            }
        }
    });




    function updateHeaderPadding() {
        const headerHeight = document.querySelector('header').offsetHeight;
        document.querySelector('main').style.paddingTop = `${headerHeight}px`;
    }

    // Initial beim Laden
    updateHeaderPadding();

    // Bei Größenänderung des Fensters
    window.addEventListener('resize', updateHeaderPadding);

}

export { navigationSubNav };
